<div class="navigation" [ngClass]="{'not-fixed': editorActive }">
    <div *ngIf="inEditModeOr(bannerEnabled)" sc-placeholder name="sitePromoBanner" [rendering]="routeData" role="banner"></div>

    <div sc-placeholder name="siteNav" [rendering]="routeData" role="navigation"></div>
</div>
<div id="content" class="content {{ bodyContainer }}" sc-placeholder name="siteBody" [rendering]="routeData" [ngClass]="{ 'not-fixed': editorActive }" role="main"></div>